import React from "react";
import './certitificates.css'
import Cert_1 from "../../assets/certs/Cert_1.png";
import Cert_2 from "../../assets/certs/Cert_2.png";
import Cert_3 from "../../assets/certs/Cert_3.png";
import Cert_4 from "../../assets/certs/Cert_4.png";
import Cert_5 from "../../assets/certs/Cert_5.png";
import Cert_6 from "../../assets/certs/Cert_6.png";
import Cert_7 from "../../assets/certs/Cert_7.png";
import Cert_8 from "../../assets/certs/Cert_8.jpg";

import {Pagination } from 'swiper/modules';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';


const Certitificates = () => {
  return (
    <section id="certifications">
      <h5>My Achievements</h5>
      <h2>Certifications</h2>
      <div className="container certificates__container">
        <Swiper // install Swiper modules
            modules={[Pagination]}
            spaceBetween={30}
            slidesPerView={1}
            pagination={{ clickable: true }}>
          <SwiperSlide>
            <article className="cert__card">
              <div className="cert__img">
                <img src={Cert_1} alt="Gen Al Essentials" />
              </div>
              <div className="cert__info">
                <h4>Gen Al Essentials</h4>
                <a
                  href="https://certificates.mavenanalytics.io/855badb9-4bea-4721-b4ea-ac7cf477261e#acc.ePUqsuDd"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  Verify Certificate
                </a>
              </div>
            </article>
          </SwiperSlide>

          <SwiperSlide>
            <article className="cert__card">
              <div className="cert__img">
                <img src={Cert_2} alt="Sql Certificate" />
              </div>
              <div className="cert__info">
                <h4>SQL</h4>
                <a
                  href="https://learn.365datascience.com/c/d5788427fb/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  Verify Certificate
                </a>
              </div>
            </article>
          </SwiperSlide>

          <SwiperSlide>
            <article className="cert__card">
              <div className="cert__img">
                <img src={Cert_3} alt="Git & Github Certificate" />
              </div>
              <div className="cert__info">
                <h4>Git & Github</h4>
                <a
                  href="https://learn.365datascience.com/c/ef035c6928/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  Verify Certificate
                </a>
              </div>
            </article>
          </SwiperSlide>

          <SwiperSlide>
            <article className="cert__card">
              <div className="cert__img">
                <img src={Cert_4} alt="web Scraping Certificate" />
              </div>
              <div className="cert__info">
                <h4>Scrape the web with Python</h4>
                <a
                  href="https://app.lewagon.school/certificates/ryubcx3a2e"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  Verify Certificate
                </a>
              </div>
            </article>
          </SwiperSlide>

          <SwiperSlide>
            <article className="cert__card">
              <div className="cert__img">
                <img src={Cert_5} alt="Computer vision Certificate" />
              </div>
              <div className="cert__info">
                <h4>Computer Vision</h4>
                <a
                  href="https://www.kaggle.com/learn/certification/pipoel/computer-vision"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  Verify Certificate
                </a>
              </div>
            </article>
          </SwiperSlide>

          <SwiperSlide>
            <article className="cert__card">
              <div className="cert__img">
                <img src={Cert_6} alt="Data Viz Certificate" />
              </div>
              <div className="cert__info">
                <h4>Data Visualization</h4>
                <a
                  href="https://www.kaggle.com/learn/certification/pipoel/data-visualization"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  Verify Certificate
                </a>
              </div>
            </article>
          </SwiperSlide>

          <SwiperSlide>
            <article className="cert__card">
              <div className="cert__img">
                <img src={Cert_7} alt="Feature Engineering Certificate" />
              </div>
              <div className="cert__info">
                <h4>Feature Engineering</h4>
                <a
                  href="https://www.kaggle.com/learn/certification/pipoel/feature-engineering"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  Verify Certificate
                </a>
              </div>
            </article>
          </SwiperSlide>

          <SwiperSlide>
            <article className="cert__card">
              <div className="cert__img">
                <img src={Cert_8} alt="Data Analysis with Python Certificate" />
              </div>
              <div className="cert__info">
                <h4>Data Analysis with Python</h4>
                <a
                  href="https://freecodecamp.org/certification/fccd652fef0-281f-46c0-9d95-241e7226773b/data-analysis-with-python-v7"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-primary btn-sm"
                >
                  Verify Certificate
                </a>
              </div>
            </article>
          </SwiperSlide>
        </Swiper>
        
      </div>
    </section>
  );
};

export default Certitificates;
